import '../../spin/style';
import '../../style/index.less';
import './index.less';
